module.exports = __webpack_public_path__ + "static/media/safety.1def70c9.jpg";